export default "__VITE_ASSET__2hTNLWwy__"